export default __webpack_public_path__ + "static/media/logo1.4330a9ae.png";